import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";

import RiskAnalysis from "../risk_analysis/RiskAnalysis";

const AcAnalytics = () => {
  const [t] = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      const uid = localStorage.getItem("user_id");
      const rid = localStorage.getItem("user_role_id");
      const cid = localStorage.getItem("customer_id");
      const oid = localStorage.getItem("organisation_id");
      if (uid && rid && cid && oid) {
        setLoading(false);
        clearInterval(interval);
      }
    }, 200);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          width: "100%",
        }}
      >
        <div style={{ color: "red", fontSize: "2rem", fontWeight: "bold" }}>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="min-h-[93vh] overflow-auto bg-white p-3 text-[#20232A] sm:p-4">
        <h1 className="mb-4 text-[24px] font-bold leading-tight text-black md:text-[30px]">
          {t("userMenuSidebar.label.RiskAnalysis")}
        </h1>

        <RiskAnalysis />
      </div>
    </>
  );
};
export default AcAnalytics;
